import axios from "axios";
import httpToken from "../../api/httpToken";
import GetEndPoints from "../../api/AppSetting";
import UsuarioAuth from "../../components/classes/UsuarioAuth";
import UsuarioDataset from "../../components/data/UsuarioDataSet";
import { createHttpHeaders } from "../../api/httpHeaders";

//import Usuario from "../../components/classes/Usuario";

const cacheKey: string = "AutUser";
const apiServico: string = "PORTAL";
const urlAut: string = "Autenticacao/Login";

export default async function Autenticar(use: UsuarioAuth): Promise<boolean> {
     var baseURL = GetEndPoints(apiServico) + urlAut;

     return new Promise((resolve, reject) => {
          var result: boolean = false;
          axios.post(baseURL, use, { headers: createHttpHeaders(false) })
               .then(function (response) {
                    if (response.status === 200) {
                         var user: UsuarioAuth = JSON.parse(JSON.stringify(response.data));
                         if (user.token.trim().length > 0) {
                              localStorage.setItem(cacheKey, JSON.stringify(response.data));
                              localStorage.setItem((new httpToken()).cacheKey, user.token);
                              let userDataSet: UsuarioDataset = new UsuarioDataset();
                              userDataSet.RecuperarPorId(user.id).then((response) => {
                                   userDataSet.AdicionarObjetoAoCache(response);
                                   result = true;
                                   resolve(result);
                              }).catch(function (error) {
                                   console.log(error);
                                   result = false;
                                   reject(result);
                              })
                         } else {
                              reject(result);
                         }
                    } else {
                         reject(result);
                         return result;
                    }
               })
               .catch(function (error) {
                    console.log(error);
                    result = false;
                    reject(result);
                    return result;
               })
               .finally(() => { });
     })
}

